/* Así funciona · Cepillo Eléctrico Giratorio con 9 Cabezales (2265282)
   Todo sale de la foto REAL de uso del cepillo sobre una estufa de vidrio negro (originales/f_899d0728d2, HD):
   la mano con el cepillo recortada, el fondo de detrás rehecho con píxeles de la misma foto (sin IA), y las cerdas
   reales que giran sobre su eje (17 cuadros: el 0 es la foto exacta, 1..8 el mismo anillo girado en octavos de mechón con
   el modelo de cono medido en la foto, 9..16 esos mismos con desenfoque de movimiento de medio mechón, a toda velocidad). La clienta toca el botón real
   del mango: se prende su pantallita y el cabezal gira solo; luego lo arrastra por el vidrio y la película leve
   (el tono claro del mismo vidrio) se va donde pasan las cerdas. Al apagarlo se frena y para en un mechón exacto
   (quieto = la foto). Ficha: gira solo, mango extensible, 9 cabezales intercambiables, carga USB.
   Piezas: tiendas/nayhogar/funciona/cepillo-electrico-giratorio-con-9-cabezales/hacer.py */
NHF.escena('cepillo-electrico-giratorio-con-9-cabezales', function (E) {
  const D = /*DATOS*/{"w":840,"h":1680,"cab":{"cx":411.0,"raiz":{"cy":1124.0,"r":118.0},"punta":{"cy":1161.4,"r":145.4},"k":0.663},"cerdas":{"src":"fn-cepillo-electrico-giratorio-con-9-cabezales-cerdas.webp","caja":[244,1086,336,190],"cuadros":17,"cols":6,"paso":0.17104},"mano":{"src":"fn-cepillo-electrico-giratorio-con-9-cabezales-mano.webp","caja":[0,449,560,815]},"lcd":{"src":"fn-cepillo-electrico-giratorio-con-9-cabezales-lcd.webp","caja":[341,792,57,39],"centro":[370,811]},"boton":{"centro":[409,830],"zona":[340,760,130,120]},"base":{"src":"fn-cepillo-electrico-giratorio-con-9-cabezales-fondo.webp","caja":[0,380,840,1040]},"limites":{"x0":-200,"x1":60,"y0":-110,"y1":45},"sucio":{"src":"fn-cepillo-electrico-giratorio-con-9-cabezales-sucio.webp","caja":[74,1044,533,272]},"vidrio":{"k":0.365},"huella":{"c":[410,1212],"r":[142,52]},"rejilla":{"x":74,"y":1044,"dx":20,"dy":10,"cols":27,"filas":28,"peso":[0,0,0,0,0,0,0,0,0,0,0.13,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.05,0,0,0,0,0.07,0,0.21,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.09,0,0,0,0,0,0,0,0,0.06,0,0.16,0,0,0,0.15,0,0,0,0,0,0.12,0,0,0,0,0,0,0,0,0,0,0.06,0,0,0,0.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.05,0.1,0,0.07,0,0,0,0,0,0,0,0,0,0.16,0.05,0,0.12,0.05,0,0,0,0,0,0,0.14,0,0.19,0,0,0,0.05,0,0,0,0,0.08,0.04,0,0.07,0,0,0,0,0,0,0,0,0,0.35,0.25,0.26,0.11,0,0,0,0,0,0.29,0.49,0.04,0,0.28,0.19,0,0,0.04,0,0,0,0,0.13,0,0.11,0.11,0,0.37,1.0,0.78,0,0,0,0.22,0.17,0,0.34,0.37,0,0.25,0.06,0.29,0,0.06,0,0,0,0.14,0.06,0,0.28,0.45,0.47,0,0,0.11,0.05,0,0,0,0.27,0,0.17,0.39,0,0,0.45,0.25,0.17,0,0.04,0.08,0.29,0.14,0.04,0,0,0.5,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0.19,0.56,0.3,0.17,0.05,0.14,0,0,0,0,0.12,0.13,0,0,0.04,0,0,0.36,0,0,0,0.35,0,0.06,0.18,0.05,0,0.18,0.51,0.51,0.42,0.15,0.06,0.07,0.07,0.05,0.03,0,0,0,0.1,0.07,0.06,0.31,0,0,0,0.1,0,0.09,0.17,0.07,0,0,0.29,0.55,0.53,0.43,0.26,0.27,0.31,0.31,0.27,0.2,0.16,0.09,0,0,0,0,0,0.18,0.1,0,0,0,0.09,0.13,0.06,0.04,0,0.19,0.53,0.54,0.46,0.44,0.59,0.52,0.51,0.62,0.43,0.4,0.42,0.1,0.3,0,0,0,0,0,0,0.06,0.15,0.31,0,0.11,0.1,0,0.16,0.51,0.5,0.5,0.54,0.56,0.56,0.57,0.55,0.54,0.48,0.34,0.18,0.24,0.17,0.06,0.16,0,0,0,0.08,0.21,0.12,0,0.2,0.17,0,0.14,0.66,0.64,0.69,0.72,0.56,0.56,0.61,0.56,0.56,0.54,0.45,0.46,0.4,0.43,0.34,0.18,0.23,0.18,0.06,0.07,0.1,0.2,0.17,0.2,0.09,0,0.11,0.7,0.71,0.55,0.62,0.62,0.56,0.56,0.57,0.63,0.62,0.49,0.56,0.45,0.51,0.52,0.55,0.61,0.46,0.34,0.27,0.15,0.18,0.18,0.19,0,0,0.07,0.36,0.51,0.54,0.58,0.59,0.5,0.53,0.56,0.68,0.52,0.36,0.37,0.49,0.54,0.55,0.56,0.56,0.55,0.45,0.35,0.28,0.27,0.21,0.13,0.16,0,0.07,0.43,0.75,0.49,0.46,0.4,0.37,0.41,0.52,0.44,0.44,0.29,0.3,0.44,0.53,0.55,0.56,0.56,0.56,0.56,0.39,0.37,0.4,0.28,0.21,0.24,0.05,0.07,0.37,0.51,0.29,0.17,0.23,0.29,0.31,0.42,0.48,0.17,0.19,0.22,0.45,0.67,0.56,0.63,0.56,0.56,0.59,0.5,0.38,0.41,0.35,0.23,0.27,0.04,0.04,0.14,0.11,0.04,0.07,0.3,0.26,0.25,0.41,0.46,0.25,0.21,0.26,0.46,0.55,0.56,0.63,0.56,0.56,0.56,0.53,0.41,0.33,0.3,0.26,0.12,0,0,0,0,0,0.15,0.33,0.38,0.38,0.41,0.66,0.51,0.44,0.31,0.38,0.44,0.55,0.61,0.8,0.41,0.41,0.47,0.38,0.28,0.19,0.12,0.06,0,0,0.15,0,0,0.21,0.51,0.55,0.65,0.51,0.48,0.52,0.5,0.39,0.25,0.52,0.55,0.49,0.35,0.23,0.22,0.28,0.12,0.09,0.06,0,0,0,0,0,0,0,0.17,0.48,0.55,0.56,0.55,0.51,0.53,0.5,0.34,0.2,0.42,0.61,0.42,0.25,0.05,0.11,0.16,0,0.23,0,0,0,0,0,0,0,0,0.12,0.27,0.38,0.41,0.44,0.52,0.52,0.46,0.29,0.23,0.37,0.31,0.24,0.19,0,0,0,0,0,0,0,0,0,0,0,0,0.08,0.17,0.31,0.48,0.37,0.35,0.42,0.35,0.41,0.42,0.23,0.35,0.13,0.15,0,0.09,0,0,0.08,0,0,0,0,0,0,0,0,0,0.03,0.1,0.14,0.1,0.11,0.1,0.11,0.1,0.08,0.08,0.08,0.04,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0]}}/*FIN*/;
  const S = E.lienzo({ w: D.w, h: D.h, vista: [70, 540, 700, 790], vistaMovil: [70, 690, 650, 670] });
  E.titulo('Préndelo y [pásalo].', 'Toca su botón: el cabezal gira solo. Después arrástralo por el vidrio de la estufa.');
  E.conSonido();
  S.cargando(true);

  /* ---------- capas (todas de la foto real) ---------- */
  S.img(D.base.src, D.base.caja, { z: 1, alt: 'Cepillo eléctrico giratorio limpiando una estufa de vidrio' });
  const SU = D.sucio.caja;
  const sucio = S.canvas(SU, { z: 2, res: Math.min(1, (window.devicePixelRatio || 1) * 0.6) });
  const C = D.cab, P0 = [C.cx, C.punta.cy];                    // centro del anillo de puntas (ancla del grupo)
  const grupo = S.grupo([0, 0, D.w, D.h], { z: 10 });
  grupo.style.transformOrigin = P0[0] + 'px ' + P0[1] + 'px';
  const sombra = S.div([P0[0] - 190, P0[1] - 20, 380, 150], { en: grupo });
  sombra.style.background = 'radial-gradient(closest-side, rgba(10,10,12,.34), rgba(10,10,12,.16) 55%, rgba(10,10,12,0))';
  const CE = D.cerdas;
  const cerdas = S.canvas(CE.caja, { en: grupo, res: Math.min(1.5, (window.devicePixelRatio || 1)) });
  S.img(D.mano.src, D.mano.caja, { en: grupo, alt: 'Mano sosteniendo el cepillo eléctrico' });
  const lcd = S.img(D.lcd.src, D.lcd.caja, { en: grupo, opacidad: 0 });
  lcd.style.transition = 'opacity .25s ease';
  const brillo = S.luz(D.lcd.centro[0], D.lcd.centro[1], 30, { en: grupo, color: '#C9E39A', ry: 16, nucleo: .25 });
  brillo.el.style.transition = 'opacity .25s ease';

  let hoja = null, imgSucio = null;
  E.cargar([D.base.src, D.mano.src, CE.src, D.sucio.src, D.lcd.src]).then(r => {
    hoja = r[2]; imgSucio = r[3]; S.cargando(false); pintarSucio(); pintarCerdas();
  });

  /* ---------- estado ---------- */
  const ST = { on: false, w: 0, ang: 0, dx: 0, dy: 0, mx: 0, my: 0, limpio: 0, listo: false, movio: false, auto: false };
  const LIM = D.limites;
  const VEL = 34;                        // rad/s a toda marcha (~320 vueltas por minuto, demostración)
  const P = CE.paso;                      // ángulo entre mechones (rad)

  /* ---------- panel ---------- */
  E.pasos(['Préndelo con su botón', 'Pásalo por el vidrio', 'Déjalo brillante']);
  E.paso(0);
  const lect = E.lectura({ etiqueta: 'Vidrio limpio' }); lect.poner('0', '%');
  const bOn = E.boton('Préndelo', () => alternar(), { icono: 'toca', primario: true });
  const bAuto = E.boton('Límpialo por mí', () => auto(), { icono: 'mano' });
  E.nota('Gira solo: tú solo lo guías. Trae mango extensible, 9 cabezales y carga por USB. En la demostración el tiempo pasa rápido.');

  /* ---------- botón real del mango ---------- */
  const BZ = D.boton.zona;
  const zBoton = S.toque(BZ, { en: grupo, redonda: true, etiqueta: 'Botón de encendido del cepillo', alTocar: () => alternar() });
  zBoton.classList.add('is-pista');
  zBoton.addEventListener('pointerdown', e => e.stopPropagation());

  function alternar() {
    ST.on = !ST.on;
    zBoton.classList.remove('is-pista');
    E.sonido.clic(); E.vibrar(12);
    lcd.style.opacity = ST.on ? 1 : 0; brillo.set(ST.on ? 0.28 : 0);
    bOn.texto(ST.on ? 'Apágalo' : 'Préndelo');
    motor();
    guia();
  }
  let ruido = null;
  function motor() {
    if (ST.on && E.sonido.activo && !ruido) ruido = E.sonido.ruido(0, 0.02, 420);
    if (!ST.on && ruido) { ruido.parar(); ruido = null; }
  }

  /* ---------- arrastrar el cepillo (la mano lo guía por el vidrio) ---------- */
  const agarre = S.div([250, 880, 330, 400], { en: grupo, clase: 'cp-agarre' });
  agarre.style.cssText += ';pointer-events:auto;cursor:grab;touch-action:none;border-radius:40%';
  agarre.setAttribute('role', 'button'); agarre.setAttribute('tabindex', '0');
  agarre.setAttribute('aria-label', 'Cepillo: arrástralo por el vidrio');
  let toma = null;
  agarre.addEventListener('pointerdown', e => {
    if (e.button > 0) return;
    const p = S.punto(e); toma = { x: p.x - ST.mx, y: p.y - ST.my }; ST.auto = false;
    try { agarre.setPointerCapture(e.pointerId); } catch (x) {}
    agarre.style.cursor = 'grabbing'; S.el.classList.add('is-tocado');
  });
  agarre.addEventListener('pointermove', e => {
    if (!toma) return;
    const p = S.punto(e);
    ST.mx = E.clamp(p.x - toma.x, LIM.x0, LIM.x1); ST.my = E.clamp(p.y - toma.y, LIM.y0, LIM.y1);
  });
  const soltar = () => { toma = null; agarre.style.cursor = 'grab'; };
  agarre.addEventListener('pointerup', soltar); agarre.addEventListener('pointercancel', soltar);
  agarre.addEventListener('keydown', e => {
    const k = { ArrowLeft: [-30, 0], ArrowRight: [30, 0], ArrowUp: [0, -20], ArrowDown: [0, 20] }[e.key];
    if (k) { e.preventDefault(); ST.mx = E.clamp(ST.mx + k[0], LIM.x0, LIM.x1); ST.my = E.clamp(ST.my + k[1], LIM.y0, LIM.y1); }
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); alternar(); }
  });

  /* ---------- película del vidrio: se borra donde pasan las cerdas ---------- */
  const G = D.rejilla;                    // peso de la película por celda (hecho en hacer.py)
  const resto = G.peso.slice(); const total = G.peso.reduce((a, b) => a + b, 0);
  function pintarSucio() { sucio.limpiar(); if (imgSucio) sucio.ctx.drawImage(imgSucio, SU[0], SU[1], SU[2], SU[3]); }
  function huella() { // huella de las cerdas sobre el vidrio (en el plano del vidrio: aplastada)
    const sc = escala();
    return { x: D.huella.c[0] + ST.dx, y: P0[1] + (D.huella.c[1] - P0[1]) * sc + ST.dy, rx: D.huella.r[0] * sc, ry: D.huella.r[1] * sc };
  }
  function frotar(k) {
    const h = huella(), ctx = sucio.ctx;
    ctx.save(); ctx.globalCompositeOperation = 'destination-out';
    ctx.translate(h.x, h.y); ctx.scale(1, h.ry / h.rx);
    const g = ctx.createRadialGradient(0, 0, h.rx * 0.55, 0, 0, h.rx);
    g.addColorStop(0, 'rgba(0,0,0,' + k + ')'); g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, h.rx, 0, 6.2832); ctx.fill(); ctx.restore();
    // cuánto queda: celdas de la rejilla dentro de la huella
    let quedan = 0;
    for (let j = 0; j < G.filas; j++) for (let i = 0; i < G.cols; i++) {
      const n = j * G.cols + i; if (!resto[n]) continue;
      const cx = G.x + (i + 0.5) * G.dx, cy = G.y + (j + 0.5) * G.dy;
      const q = Math.pow((cx - h.x) / h.rx, 2) + Math.pow((cy - h.y) / h.ry, 2);
      if (q < 0.85) resto[n] = Math.max(0, resto[n] - G.peso[n] * k * 1.15);
      quedan += resto[n];
    }
    ST.limpio = Math.round(100 * (1 - quedan / total));
    lect.poner(String(Math.min(100, ST.limpio)), '%');
    if (ST.limpio >= 93 && !ST.listo) terminar();
  }
  function terminar() {
    ST.listo = true;
    // lo poquito que quede se va con la última pasada
    const ctx = sucio.ctx; ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.globalAlpha = 1;
    E.animarP(700, k => { ctx.fillStyle = 'rgba(0,0,0,' + (0.25 * k) + ')'; ctx.fillRect(SU[0], SU[1], SU[2], SU[3]); }).then(() => ctx.restore());
    lect.poner('100', '%'); E.sonido.bip(1800);
    guia();
  }

  /* ---------- cerdas: cuadro según el ángulo, desenfoque según la velocidad ---------- */
  function pintarCerdas() {
    if (!hoja) return;
    const c = cerdas.ctx, b = CE.caja, cols = CE.cols, n = CE.cuadros;
    cerdas.limpiar();
    const celda = i => { const f = Math.floor(i / cols), k = i % cols; return [k * b[2], f * b[3]]; };
    const dibujar = (i, a) => { const [sx, sy] = celda(i); c.globalAlpha = a; c.drawImage(hoja, sx, sy, b[2], b[3], b[0], b[1], b[2], b[3]); };
    if (ST.w <= 0.001) { dibujar(0, 1); c.globalAlpha = 1; return; }      // quieto = la foto exacta
    const K = (n - 1) / 2;                                                 // 8 cuadros nítidos + 8 barridos
    const fase = ((ST.ang % P) + P) % P / P;
    const i = Math.min(K - 1, Math.floor(fase * K));
    const bl = E.clamp((ST.w - 2.5) / 9, 0, 1);
    if (bl < 0.98) dibujar(1 + i, 1);
    if (bl > 0.01) dibujar(1 + K + i, bl < 0.98 ? bl : 1);
    c.globalAlpha = 1;
  }
  const escala = () => 1 + ST.dy * 0.0006;

  /* ---------- bucle ---------- */
  let tFrote = 0;
  E.bucle((t, dt) => {
    // motor: arranca en ~0,6 s y se frena despacio; al quedar quieto para en un mechón exacto (= la foto)
    if (ST.on) { ST.w = Math.min(VEL, ST.w + dt * 60); ST.ang += ST.w * dt; }
    else if (ST.w > 0) {
      const falta = P - (((ST.ang % P) + P) % P);      // lo que falta para el próximo mechón
      ST.w = Math.max(0, ST.w - dt * 38);
      if (ST.w < 3) ST.w = Math.max(0.8, Math.min(ST.w, Math.sqrt(2 * 6 * falta)));
      if (ST.w < 3 && ST.w * dt >= falta) { ST.ang += falta; ST.w = 0; } else ST.ang += ST.w * dt;
    }
    // la mano sigue el dedo con un poco de inercia (como una mano de verdad)
    const ax = ST.mx - ST.dx, ay = ST.my - ST.dy;
    ST.dx += ax * Math.min(1, dt * 14); ST.dy += ay * Math.min(1, dt * 14);
    const vib = ST.w > 5 && !E.reduce ? 0.5 : 0;
    const jx = vib ? (Math.random() - 0.5) * vib : 0, jy = vib ? (Math.random() - 0.5) * vib : 0;
    grupo.style.transform = 'translate3d(' + (ST.dx + jx).toFixed(2) + 'px,' + (ST.dy + jy).toFixed(2) + 'px,0) scale(' + escala().toFixed(4) + ')';
    pintarCerdas();
    // frota: solo girando y moviéndose (o a toda marcha encima de la película)
    const mov = Math.hypot(ax, ay);
    if (ST.w > 12 && !ST.listo) {
      tFrote += dt;
      if (tFrote > 0.05) { frotar(E.clamp(0.16 + mov * 0.01, 0.16, 0.5) * (ST.w / VEL)); tFrote = 0; if (mov > 2) ST.movio = true; guia(); }
    }
  });

  /* ---------- guía ---------- */
  function guia() {
    let p = 0, txt = 'Toca el botón del mango para prenderlo', ic = 'toca';
    if (ST.on || ST.w > 0) { p = 1; txt = 'Arrastra el cepillo por el vidrio'; ic = 'mano'; }
    if (ST.movio && ST.limpio > 30) { p = 2; txt = 'Pásalo por donde quede opaco'; ic = 'mano'; }
    if (ST.listo) { p = 3; txt = ''; }
    E.paso(p); S.pista(txt || null, ic);
    if (ST.listo) { bAuto.hidden = true; E.listo('Gira solo: tú solo lo pasas. Con el mango extensible llegas al piso y a lo alto sin agacharte.', reiniciar); }
  }

  /* ---------- "Límpialo por mí": recorrido en zigzag por el vidrio ---------- */
  async function auto() {
    if (ST.auto) return; ST.auto = true; bAuto.hidden = true;
    if (!ST.on) { alternar(); await E.esperar(700); }
    // un zigzag por el vidrio y después a donde más película quede, hasta dejarlo limpio
    const filas = [LIM.y0 + 10, (LIM.y0 + LIM.y1) / 2, LIM.y1 - 5];
    for (let f = 0; f < filas.length && ST.auto && !ST.listo; f++) {
      const ida = f % 2 === 0 ? [LIM.x1, LIM.x0] : [LIM.x0, LIM.x1];
      ST.my = filas[f];
      await E.animarP(1300, k => { if (ST.auto) ST.mx = E.lerp(ida[0], ida[1], k); });
    }
    for (let v = 0; v < 14 && ST.auto && !ST.listo; v++) {
      let mejor = -1, mp = 0;
      resto.forEach((r, n) => { if (r > mp) { mp = r; mejor = n; } });
      if (mejor < 0) break;
      const i = mejor % G.cols, j = Math.floor(mejor / G.cols);
      ST.mx = E.clamp(G.x + (i + 0.5) * G.dx - D.huella.c[0], LIM.x0, LIM.x1);
      ST.my = E.clamp(G.y + (j + 0.5) * G.dy - D.huella.c[1], LIM.y0, LIM.y1);
      await E.esperar(520);
    }
    if (!ST.listo) bAuto.hidden = false;
    ST.auto = false;
  }

  function reiniciar() {
    E.noListo(); ST.listo = false; ST.movio = false; ST.auto = false; ST.limpio = 0;
    for (let n = 0; n < resto.length; n++) resto[n] = G.peso[n];
    if (ST.on) alternar();
    ST.mx = 0; ST.my = 0;
    pintarSucio(); lect.poner('0', '%'); bAuto.hidden = false; zBoton.classList.add('is-pista'); guia();
  }
  S.pista('Toca el botón del mango para prenderlo', 'toca');
});
